import { render, staticRenderFns } from "./formAccountSetting.vue?vue&type=template&id=cc81067c&"
import script from "./formAccountSetting.vue?vue&type=script&lang=js&"
export * from "./formAccountSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports